import { RenewalContract } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchRenewalContract } from './RenewalContractSlice';
import { useRenewalContractSelector } from './RenewalContractSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useRenewalContract(): AbstractDataState<RenewalContract[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchRenewalContract, useRenewalContractSelector);
}
